import RoyaltiesEditorService from "./RoyaltiesEditorService";

class Services {
  constructor(params) {
    this['royalties-editor'] = RoyaltiesEditorService;
  }
}

export default new Services();